export const PREVIEW_ROW_COUNT = 5;

export type AchFieldConfig = {
  field: API.ACHImport.AchField;
  labelKey: string;
  required: boolean;
  defaultNoteKey: string | null;
};

export const ACH_FIELDS: AchFieldConfig[] = [
  {
    field: "recipient_name",
    labelKey: "column-mapping-field-recipient-name",
    required: true,
    defaultNoteKey: null,
  },
  {
    field: "amount",
    labelKey: "column-mapping-field-amount",
    required: true,
    defaultNoteKey: null,
  },
  {
    field: "account_number",
    labelKey: "column-mapping-field-account-number",
    required: true,
    defaultNoteKey: null,
  },
  {
    field: "routing_number",
    labelKey: "column-mapping-field-routing-number",
    required: true,
    defaultNoteKey: null,
  },
  {
    field: "date",
    labelKey: "column-mapping-field-date",
    required: false,
    defaultNoteKey: null,
  },
  {
    field: "action",
    labelKey: "column-mapping-field-action",
    required: false,
    defaultNoteKey: "column-mapping-field-action-default",
  },
  {
    field: "description",
    labelKey: "column-mapping-field-description",
    required: false,
    defaultNoteKey: null,
  },
  {
    field: "account_type",
    labelKey: "column-mapping-field-account-type",
    required: false,
    defaultNoteKey: "column-mapping-field-account-type-default",
  },
];
